import React, { useState, useRef, useEffect } from 'react';
import { Box, IconButton } from '@material-ui/core';
import previewElementStyle, { StyledInputBase } from './PeviewElements.style';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { debounce } from 'helper/helper';

function PreviewSearch({ cbPreviewSearch, clear }) {
	const [searchText, setSearchText] = useState('');
	const classes = previewElementStyle();
	const searchInputRef = useRef();

	useEffect(() => {
		if (clear) {
			handleClearSearch();
		}
	}, [clear]);

	const handleSearch = debounce((text) => {
		const txt = text.trim();
		setSearchText(txt);
		cbPreviewSearch(txt);
	}, 300);

	const handleClearSearch = () => {
		searchInputRef.current.value = '';
		setSearchText('');
		cbPreviewSearch('');
	};

	return (
		<>
			<Box className={classes.searchBox}>
				<Box className={classes.searchBoxIcon}>
					<SearchIcon />
				</Box>
				<StyledInputBase
					inputRef={searchInputRef}
					id="search-field"
					onChange={(e) => handleSearch(e.target.value)}
					placeholder="Search…"
					inputProps={{ 'aria-label': 'search' }}
				/>
				{searchText !== '' && (
					<Box className={classes.crossIcon}>
						<IconButton id="clear" onClick={handleClearSearch} aria-label="Clear search">
							<CloseIcon fontSize="medium" />
						</IconButton>
					</Box>
				)}
			</Box>
		</>
	);
}

export default PreviewSearch;
